const PLATFORM_TENANT_ID = (
  import.meta.env.VITE_DSS_PLATFORM_TENANT_ID || ''
).trim()

export function isPlatformTenant(tenantData) {
  if (!PLATFORM_TENANT_ID) {
    return false
  }

  return String(tenantData?.id ?? '') === PLATFORM_TENANT_ID
}

export function isSupportRequestEnabled() {
  const value = String(import.meta.env.VITE_SUPPORT_REQUEST_ENABLED ?? '')

  return value.trim().toLowerCase() === 'true'
}

const SUPPORT_REQUEST_BLOCKED_NAME_PREFIX = 'PPC'

export function isSupportRequestBlockedForCompany(tenantData, companyData) {
  const tenantName = companyData?.tenantName || tenantData?.tenantName || tenantData?.name

  return [tenantName, companyData?.name].some(name =>
    String(name ?? '').trim().toUpperCase().startsWith(SUPPORT_REQUEST_BLOCKED_NAME_PREFIX),
  )
}
